import { IAnalystsConsensus, IAnalyst, IStocksDto } from "../../../../../../services/tipRanks/types";
import { analystForecasts } from "@/services/tipRanks";

export const analystForecastsApi = {
    getAnalysts: async (ticker: string): Promise<IAnalyst[]> => {
        return await analystForecasts.getAnalysts(ticker);
    },

    getConsensusOverTime: async (ticker: string): Promise<IAnalystsConsensus | []> => {
        return await analystForecasts.getConsensusOverTime(ticker);
    },

    getIAnalystsConsensus: async (ticker: string): Promise<IAnalystsConsensus | []> => {
        return await analystForecasts.getIAnalystsConsensus(ticker);
    },

    getTechnologyTopStocks: async (): Promise<IStocksDto[]> => {
        return await analystForecasts.getTechnologyTopStocks();
    },
};
